import { render, staticRenderFns } from "./HomeAdvertising.vue?vue&type=template&id=73973949&lang=pug&"
import script from "./HomeAdvertising.vue?vue&type=script&lang=js&"
export * from "./HomeAdvertising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports